// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"9c40cced","242":"98479b38","631":"82b64315","643":"0e02bb73","734":"a484f421","763":"38014475","931":"33d571d6"}[chunkId] + ".chunk.js";
};